import React from "react";
import PropTypes from "prop-types";
import { Card, Divider, Grid } from "@mui/material";
import MDBox from "../../MDBox";
import MDTypography from "../../MDTypography";

export default function BankCard({
  color,
  title,
  description,
  rowNumber,
  deleteButton,
  editButton,
  children,
}: any) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" pt={1} px={2}>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="h5" fontWeight="light" color="dark" ml={1}>
            <MDBox
              variant="gradient"
              bgColor={"light"}
              color={"light" ? "dark" : "white"}
              coloredShadow={color}
              borderRadius="xl"
              display="flex"
              justifyContent="center"
              alignItems="center"
              minWidth="4rem"
              minHeight="4rem"
              mt={-4}
              p={"3px"}
            >
              <img
                alt=""
                width={"60"}
                src={require("../../../Asset/images/backkk.png")}
              />
            </MDBox>
          </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />

      <MDBox sx={{ flex: 1 }}>{children}</MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <Grid container spacing={3} justifyContent={"space-around"}>
          <Grid item xs={12} md={12} lg={3}>
            <MDBox>{editButton}</MDBox>
          </Grid>
          <Grid item xs={12} md={12} lg={3}>
            <MDBox>{deleteButton}</MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
// Setting default values for the props of ComplexStatisticsCard
BankCard.defaultProps = {
  color: "info",
};
// Typechecking props for the ComplexStatisticsCard
BankCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",

    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  rowNumber: PropTypes.string,
  deleteButton: PropTypes.node,
  editButton: PropTypes.node,
  children: PropTypes.node,
};
